<div class="layout-wrapper layout-content-navbar" style="background-color: #F8F8FF;">
  <div class="layout-container">
    <!-- Sidebar Code Starts Here -->
    <button class="menu-btn">&#9776;</button>
    <div class="sidebar-card">
      <aside id="layout-menu" class="layout-menu menu-vertical menu bg-menu-theme">
        <div class="menu-inner-shadow"></div>
        <div class="menu-item">
          <div class="px-6 py-2 border-bottom d-flex justify-content-between align-items-center w-100">
            <h5 class="folder-heading">Folders</h5>
          </div>
          
          <!-- Schedule of Activities -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'ScheduleOfActivities'}"
     (click)="onFolderClick('ScheduleOfActivities')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Schedule of Activities</span>
    </div>
  </a>
  <!-- Sub-items for Schedule of Activities -->
  <ul class="list-group mt-2 ps-4" *ngIf="isScheduleOfActivitiesVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getScheduleForms()"
        (click)="navigateToSchedule(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

          <!-- Screening Visit -->
          <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
               class="menu-link d-flex justify-content-between align-items-center"
               [ngClass]="{'highlighted': selectedFolder === 'Screening Visit'}"
               (click)="onFolderClick('Screening Visit')">
              <div>
                <i class="menu-icon tf-icons bx bx-layout"></i>
                <span>Screening Visit</span>
              </div>
            </a>
            <!-- Sub-items for Screening Visit -->
            <ul class="list-group mt-2 ps-4" *ngIf="isScreeningVisible">
              <li class="list-group-item border-0 p-1" 
                  *ngFor="let form of getScreeningForms()"
                  (click)="navigateToScreening(form.route)"
                  [ngClass]="{'highlighted-form': selectedForm === form.route}"
                  style="font-size: 13px; cursor: pointer;">
                {{ form.name }}
              </li>
            </ul>
          </div>

          <!-- Baseline Visit -->
          <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
               class="menu-link d-flex justify-content-between align-items-center"
               [ngClass]="{'highlighted': selectedFolder === 'Baseline Visit'}"
               (click)="onFolderClick('Baseline Visit')">
              <div>
                <i class="menu-icon tf-icons bx bx-layout"></i>
                <span>Baseline Visit</span>
              </div>
            </a>
            <!-- Sub-items for Baseline Visit -->
            <ul class="list-group mt-2 ps-4" *ngIf="isBaselineVisible">
              <li class="list-group-item border-0 p-1" 
                  *ngFor="let form of getBaselineForms()"
                  (click)="navigateToBaseline(form.route)"
                  [ngClass]="{'highlighted-form': selectedForm === form.route}"
                  style="font-size: 13px; cursor: pointer;">
                {{ form.name }}
              </li>
            </ul>
          </div>

          <!-- Medicine Dispensing Visit -->
          <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
               class="menu-link d-flex justify-content-between align-items-center"
               [ngClass]="{'highlighted': selectedFolder === 'Medicine Dispensing Visit'}"
               (click)="onFolderClick('Medicine Dispensing Visit')">
              <div>
                <i class="menu-icon tf-icons bx bx-layout"></i>
                <span>Medicine Dispensing Visit</span>
              </div>
            </a>
            <!-- Sub-items for Medicine Dispensing Visit -->
            <ul class="list-group mt-2 ps-4" *ngIf="isMedicineDispensingVisible">
              <li class="list-group-item border-0 p-1" 
                  *ngFor="let form of getMedicineDispensingForms()"
                  (click)="navigateToMedicineDispensing(form.route)"
                  [ngClass]="{'highlighted-form': selectedForm === form.route}"
                  style="font-size: 13px; cursor: pointer;">
                {{ form.name }}
              </li>
            </ul>
          </div>

         

          
          <!-- Followup Visit -->
          <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
               class="menu-link d-flex justify-content-between align-items-center"
               [ngClass]="{'highlighted': selectedFolder === 'Followup Visit'}"
               (click)="onFolderClick('Followup Visit')">
              <div>
                <i class="menu-icon tf-icons bx bx-layout"></i>
                <span>Follow up Visit</span>
              </div>
            </a>
            <!-- Sub-items for Followup Visit -->
            <ul class="list-group mt-2 ps-4" *ngIf="isFollowupVisible">
              <li class="list-group-item border-0 p-1" 
                  *ngFor="let form of getFollowupForms()"
                  (click)="navigateToFollowup(form.route)"
                  [ngClass]="{'highlighted-form': selectedForm === form.route}"
                  style="font-size: 13px; cursor: pointer;">
                {{ form.name }}
              </li>
            </ul>
          </div>


           <!-- Study Completion / Termination Record -->
          <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
              class="menu-link d-flex justify-content-between align-items-center"
              [ngClass]="{'highlighted': selectedFolder === 'Study Completion / Termination Record'}"
              (click)="onFolderClick('Study Completion / Termination Record')">
              <div>
                <i class="menu-icon tf-icons bx bx-layout"></i>
                <span>Study Completion / Termination Record</span>
              </div>
            </a>
            <!-- Sub-items for Study Completion / Termination Record -->
            <ul class="list-group mt-2 ps-4" *ngIf="isStudyCompletionVisible">
              <li class="list-group-item border-0 p-1" 
                  *ngFor="let form of getStudyCompletionForms()"
                  (click)="navigateToStudyCompletion(form.route)"
                  [ngClass]="{'highlighted-form': selectedForm === form.route}"
                  style="font-size: 13px; cursor: pointer;">
                {{ form.name }}
              </li>
            </ul>
          </div>

          <!-- Medical History -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Medical History'}"
     (click)="onFolderClick('Medical History')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Medical History</span>
    </div>
  </a>
  <!-- Sub-items for Medical History -->
  <ul class="list-group mt-2 ps-4" *ngIf="isMedicalHistoryVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getMedicalHistoryForms()"
        (click)="navigateToMedicalHistory(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

      <!-- Vital Signs -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Vital Signs'}"
     (click)="onFolderClick('Vital Signs')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Vital Signs</span>
    </div>
  </a>
  <!-- Sub-items for Vital Signs -->
  <ul class="list-group mt-2 ps-4" *ngIf="isVitalSignsVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getVitalSignsForms()"
        (click)="navigateToVitalSigns(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

<!-- Laboratory Investigation -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Laboratory Investigation'}"
     (click)="onFolderClick('Laboratory Investigation')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Laboratory Investigation</span>
    </div>
  </a>
  <!-- Sub-items for Laboratory Investigation -->
  <ul class="list-group mt-2 ps-4" *ngIf="isLaboratoryVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getLaboratoryForms()"
        (click)="navigateToLaboratory(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>


         
          
          <!-- Randomization Visit -->
          <!-- <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
               class="menu-link" 
               [ngClass]="{'highlighted': selectedFolder === 'randomization'}" 
               (click)="selectFolder('randomization')">
              <i class="menu-icon tf-icons bx bx-layout"></i>
              <div>Randomization Visit</div>
            </a>
          </div> -->

          <!-- Visit -->
          <!-- <div class="menu-item">
            <a href="javascript:void(0);" class="menu-link" [routerLink]="['/visits']"
               [ngClass]="{'highlighted': selectedFolder === 'Visit'}" 
               (click)="selectFolder('Visit')"
               style="cursor: default;"
               [queryParams]="{ name: queryParams.name, studyId: queryParams.studyId, centers: queryParams.centers, subjectId: queryParams.subjectId }">
              <i class="menu-icon tf-icons bx bx-layout"></i>
              <div>Visit</div>
            </a>
          </div> -->

          <!-- Study Completion Records --
          <div class="menu-item">
            <a href="javascript:void(0);" class="menu-link"
               [ngClass]="{'highlighted': selectedFolder === 'Study completion records'}" 
               (click)="selectFolder('Study completion records')"
               style="cursor: default;">
              <i class="menu-icon tf-icons bx bx-layout"></i>
              <div>Study Completion Records</div>
            </a>
          </div>-->

         <!-- Adverse Events Records Log -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Adverse Events Records Log'}"
     (click)="onFolderClick('Adverse Events Records Log')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Adverse Events Records Log</span>
    </div>
  </a>
  <!-- Sub-items for Adverse Events -->
  <ul class="list-group mt-2 ps-4" *ngIf="isAdverseEventsVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getAdverseEventsForms()"
        (click)="navigateToAdverseEvents(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>


          <!-- Concomitant Medication Log -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Concomitant Medication Log'}"
     (click)="onFolderClick('Concomitant Medication Log')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Concomitant Medication Log</span>
    </div>
  </a>
  <!-- Sub-items for Concomitant Medication Log -->
  <ul class="list-group mt-2 ps-4" *ngIf="isConcomitantMedicationVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getConcomitantMedicationForms()"
        (click)="navigateToConcomitantMedication(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

 <!-- Physical and Systemic Examination -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Physical and Systemic Examination'}"
     (click)="onFolderClick('Physical and Systemic Examination')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Physical and Systemic Examination</span>
    </div>
  </a>
  <!-- Sub-items for Physical and Systemic Examination -->
  <ul class="list-group mt-2 ps-4" *ngIf="isPhysicalSystemicVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getPhysicalSystemicForms()"
        (click)="navigateToPhysicalSystemic(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>
 <!-- Rescue Medication Log -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Rescue Medication Log'}"
     (click)="onFolderClick('Rescue Medication Log')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Rescue Medication Log</span>
    </div>
  </a>
  <!-- Sub-items for Rescue Medication Log -->
  <ul class="list-group mt-2 ps-4" *ngIf="isRescueMedicationVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getRescueMedicationForms()"
        (click)="navigateToRescueMedication(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

<!-- Prior Medication Log -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Prior Medication Log'}"
     (click)="onFolderClick('Prior Medication Log')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Prior Medication Log</span>
    </div>
  </a>
  <!-- Sub-items for Prior Medication Log -->
  <ul class="list-group mt-2 ps-4" *ngIf="isPriorMedicationVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getPriorMedicationForms()"
        (click)="navigateToPriorMedication(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

      

       
      
        <!-- IDRS -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'IDRS'}"
     (click)="onFolderClick('IDRS')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>IDRS</span>
    </div>
  </a>
  <!-- Sub-items for IDRS -->
  <ul class="list-group mt-2 ps-4" *ngIf="isIDRSVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getIdrsForms()"
        (click)="navigateToIDRS(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>

<!-- Protocol Deviation / Violation / Waiver Log -->
<div class="menu-item">
  <a href="javascript:void(0);" style="cursor: default;"
     class="menu-link d-flex justify-content-between align-items-center"
     [ngClass]="{'highlighted': selectedFolder === 'Protocol Deviation / Violation / Waiver Log'}"
     (click)="onFolderClick('Protocol Deviation / Violation / Waiver Log')">
    <div>
      <i class="menu-icon tf-icons bx bx-layout"></i>
      <span>Protocol Deviation/Violation/Waiver Log</span>
    </div>
  </a>
  <!-- Sub-items for Protocol Deviation -->
  <ul class="list-group mt-2 ps-4" *ngIf="isProtocolDeviationVisible">
    <li class="list-group-item border-0 p-1" 
        *ngFor="let form of getProtocolDeviationForms()"
        (click)="navigateToProtocolDeviation(form.route)"
        [ngClass]="{'highlighted-form': selectedForm === form.route}"
        style="font-size: 13px; cursor: pointer;">
      {{ form.name }}
    </li>
  </ul>
</div>






          
           <!-- Principal Investigator's Signature -->
           <div class="menu-item">
            <a href="javascript:void(0);" style="cursor: default;"
               class="menu-link d-flex justify-content-between align-items-center"
               [ngClass]="{'highlighted': selectedFolder === 'Principal Investigator\'s Signature'}"
               (click)="onFolderClick('Principal Investigator\'s Signature')">
              <div>
                <i class="menu-icon tf-icons bx bx-layout"></i>
                <span>Principal Investigator's Signature</span>
              </div>
            </a>
            <!-- Sub-items for Principal Investigator's Signature -->
            <ul class="list-group mt-2 ps-4" *ngIf="isSignatureVisible">
              <li class="list-group-item border-0 p-1" 
                  *ngFor="let form of getSignatureForms()"
                  (click)="navigateToSignature(form.route)"
                  [ngClass]="{'highlighted-form': selectedForm === form.route}"
                  style="font-size: 13px; cursor: pointer;">
                {{ form.name }}
              </li>
            </ul>
          </div>
          
       





        </div>
      </aside>
    </div>
    <!-- Sidebar Code Ends Here -->
  </div>
</div>